export default __webpack_public_path__ + "static/media/after_sponsor.f8255545.webp";